export default __webpack_public_path__ + "static/media/Doxxed Team 1.7b4a175a.jpg";